module.exports = __webpack_public_path__ + "media/images/wfc/venue-8-ce81f6218fc60cd230f399c630c0d344.jpg";